import PropTypes from "prop-types";

export default function LevelCard({ image, title, description }) {
  return (
    <article className="school-level">
      <img src={image} alt="" loading="lazy" />
      <div>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </article>
  );
}

LevelCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
